.noRowBorder tbody {
  border-bottom: none !important;
  border-top: 1px !important;
}
